var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(-427 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835",
    transform: "translate(427 98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fbae47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M418.869,284.787c-.332-.452-1.313-.414-1.168.081.93,3.189-.84,3.68-.815,2.163.094-5.688-1.949-9.043-3.844-10.512a.564.564,0,0,0-.932.457c.341,2.08,1.12,4.366-2.02,7.137-5.735,5.061-4.339,9.435-4.339,9.435a7.206,7.206,0,0,0,5.875,4.841.142.142,0,0,0,.08-.268,1,1,0,0,1-.282-.137c-4.787-4.615-.359-8.225,1.189-9.981a.353.353,0,0,1,.613.17c.632,2.781,2.137,4.165,2.8,5.357,1.317,2.361.539,3.8-.285,4.567a.137.137,0,0,0,.115.236C422.4,296.839,422.024,289.085,418.869,284.787Z",
    transform: "translate(-397.603 -271.391)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gas-icon.1b5c4c63e49295c2d064f078c55aeaee.svg";
export { ForwardRef as ReactComponent };